export default __webpack_public_path__ + "locales/fr/ChangeEmailDialog.json?hash=3750406eb836b91530d4104f95a285ce";